export const FIND_ASSIGNABLE_FILE_PRODUCTS = `
  query FindAssignableProductsForFile($filter: FindAssignableFileProductsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    media {
      findAssignableProductsForFile(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items { id name }
      }
    }
  }
`;
